import React, { useState } from 'react';
import styled from 'styled-components';

// Import contact image
import contactImage from '../assets/contact_image.jpg';

const ContactContainer = styled.div`
  padding: 40px 0;
  max-width: 800px;
  margin: 0 auto;
`;

const ContactHeading = styled.h1`
  font-size: 2rem;
  margin-bottom: 30px;
  position: sticky;
  top: 180px;
  background-color: #000;
  z-index: 100;
  padding: 15px 0;
  margin-top: -15px;

  @media (max-width: 768px) {
    font-size: 1.75rem;
    top: 140px;
  }
`;

const ContactContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ContactImageContainer = styled.div`
  width: 100%;
`;

const ContactImg = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
`;

const ContactInfo = styled.div`
  margin-bottom: 30px;
  line-height: 1.6;
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Label = styled.label`
  font-size: 0.9rem;
  color: #ccc;
`;

const Input = styled.input`
  padding: 10px;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 4px;
  color: #fff;
  font-family: inherit;
`;

const TextArea = styled.textarea`
  padding: 10px;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 4px;
  color: #fff;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;
`;

const SubmitButton = styled.button`
  padding: 12px 20px;
  background: #333;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-family: inherit;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  
  &:hover {
    background: #555;
  }
`;

const SuccessMessage = styled.div`
  padding: 15px;
  background: #225522;
  color: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
`;

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would send the form data to a server
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
    
    // Hide success message after 5 seconds
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };
  
  return (
    <ContactContainer>
      <ContactHeading>Contact</ContactHeading>
      
      <ContactContent>
        <ContactImageContainer>
          <ContactImg src={contactImage} alt="Joey M. Robinson Studio" />
        </ContactImageContainer>

        <div>
          <ContactInfo>
            <p>For inquiries about artwork, commissions, or exhibitions, please get in touch.</p>
            <p><strong>Email:</strong> info@joeymrobinson.com</p>
            <p><strong>Studio:</strong> Seattle, Washington</p>
          </ContactInfo>

          {isSubmitted && (
            <SuccessMessage>
              Thank you for your message! We'll get back to you soon.
            </SuccessMessage>
          )}

          <ContactForm onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="name">Name</Label>
              <Input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name} 
                onChange={handleChange} 
                required 
              />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="email">Email</Label>
              <Input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                required 
              />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="subject">Subject</Label>
              <Input 
                type="text" 
                id="subject" 
                name="subject" 
                value={formData.subject} 
                onChange={handleChange} 
                required 
              />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="message">Message</Label>
              <TextArea 
                id="message" 
                name="message" 
                value={formData.message} 
                onChange={handleChange} 
                required 
              />
            </FormGroup>
            
            <SubmitButton type="submit">Send Message</SubmitButton>
          </ContactForm>
        </div>
      </ContactContent>
    </ContactContainer>
  );
}

export default Contact;